import React from 'react';
import { Button, CloseButton, Flex, Group, Input, Paper } from '@mantine/core';

import styles from './TagsMenu.module.scss';

interface Props {
  isOpen: boolean;
  onSubmit: (tagName: string) => Promise<void>;
  onClose: () => void;
}

const CreateTagMenu = ({ isOpen, onSubmit, onClose }: Props) => {
  const [newTagName, setNewTagName] = React.useState('');

  const [isSubmitting, setIsSubmitting] = React.useState(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [submitError, setSubmitError] = React.useState(false);

  const handleTagCreateSubmit = async () => {
    const newTag = newTagName.trim();

    if (!newTag) return;

    try {
      setIsSubmitting(true);
      setSubmitError(false);

      await onSubmit(newTag);
      setNewTagName('');
      onClose();
    } catch {
      setSubmitError(true);
    } finally {
      setIsSubmitting(false);
    }
  };

  React.useEffect(() => {
    const reset = () => {
      setNewTagName('');
    };

    if (!isOpen) {
      reset();
    }
  }, [isOpen]);

  if (!isOpen) {
    return null;
  }

  return (
    <>
      <div className={styles.overlay} />
      <Paper
        classNames={{
          root: styles.menu,
        }}
      >
        <Group gap={10} justify="space-between">
          <h2>Create New Tag</h2>
          <CloseButton onClick={onClose} />
        </Group>

        <Input
          placeholder="Tag 1"
          value={newTagName}
          onChange={(event) => setNewTagName(event.currentTarget.value)}
          classNames={{ input: styles.input }}
        />

        <Flex justify="center" align="center" gap={10} mt={30}>
          <Button
            variant="subtle"
            onClick={() => setNewTagName('')}
            classNames={{ root: styles.cancelButton }}
            disabled={isSubmitting}
          >
            Clear
          </Button>
          <Button
            onClick={handleTagCreateSubmit}
            disabled={newTagName.trim() === ''}
            classNames={{ root: styles.submitButton }}
            loading={isSubmitting}
            loaderProps={{ type: 'dots' }}
          >
            Create
          </Button>
        </Flex>
      </Paper>
    </>
  );
}

export default CreateTagMenu;
